// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"afb9cd7e28010ef02cee","678":"cbda03b8cbf311ac0c29"}[chunkId] + ".js";
};